/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import scrollIntoView from 'scroll-into-view';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import Animation from 'modules/animation-timeline';
import AnimationScroll from 'modules/animation-scroll';
import container from 'modules/section-content';
import splash from './view/landing.pug';
import metadata from './metadata.json';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/retail', render, snippets);
  page.exit('/retail', unmountContactForm, resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="retail"
      subject="New lead from Retail landing page"
      formId="retail-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupClickHandlers();
  setupContactForm();
  setupAnimations();
  next();
}

function setupClickHandlers() {
  const acquireTargetElem = document.getElementById('scroll-spy-acquire');
  const unifyTargetElem = document.getElementById('scroll-spy-unify');
  const personalizeTargetElem = document.getElementById('scroll-spy-personalize');
  const partnerTargetElem = document.getElementById('scroll-spy-partner');

  const $acquireSection = $('.retail-page section[role="navigation"] .section-acquire');
  const $unifySection = $('.retail-page section[role="navigation"] .section-unify');
  const $personalizeSection = $('.retail-page section[role="navigation"] .section-personalize');
  const $partnerSection = $('.retail-page section[role="navigation"] .section-partner');

  $acquireSection.on('click', () => scrollIntoView(acquireTargetElem, { time: 500 }));
  $unifySection.click(() => scrollIntoView(unifyTargetElem, { time: 500 }));
  $personalizeSection.click(() => scrollIntoView(personalizeTargetElem, { time: 500 }));
  $partnerSection.click(() => scrollIntoView(partnerTargetElem, { time: 500 }));
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'retail-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}

function setupAnimations() {
  const heroAnimation = setupHeroAnimation();
  const acquireAnimation = setupAcquireAnimation();
  const unifyAnimation = setupUnifyAnimation();
  const personalizeAnimation = setupPersonalizeAnimation();
  const partnerAnimation = setupPartnerAnimation();
  const $navigation = $('#retail-page-navigation');
  const $acquireSection = $('#retail-page-navigation .section-acquire span');
  const $unifySection = $('#retail-page-navigation .section-unify span');
  const $personalizeSection = $('#retail-page-navigation .section-personalize span');
  const $partnerSection = $('#retail-page-navigation .section-partner span');

  heroAnimation.run();
  animationScroll.add({
    id: 'acquire-section',
    animation: acquireAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'unify-section',
    animation: unifyAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'personalize-section',
    animation: personalizeAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'partner-section',
    animation: partnerAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-container',
    onEnter: () => $navigation.addClass('fixed'),
    onLeave: () => $navigation.removeClass('fixed')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-acquire',
    onEnter: () => $acquireSection.addClass('section-active'),
    onLeave: () => $acquireSection.removeClass('section-active'),
    options: { offsetTop: -140 }
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-unify',
    onEnter: () => $unifySection.addClass('section-active'),
    onLeave: () => $unifySection.removeClass('section-active')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-personalize',
    onEnter: () => $personalizeSection.addClass('section-active'),
    onLeave: () => $personalizeSection.removeClass('section-active')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-partner',
    onEnter: () => $partnerSection.addClass('section-active'),
    onLeave: () => $partnerSection.removeClass('section-active')
  });

  animationScroll.start();
}

function setupHeroAnimation() {
  const $elem = $('.retail-page section[role="hero"] .hero-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .removeClass('callout-1 callout-2 callout-3')
    .fadeIn(300)
    .delay(300)
    .toggleClass('callout-1')
    .delay(300)
    .toggleClass('callout-2')
    .delay(300)
    .toggleClass('callout-3');
}

function setupAcquireAnimation() {
  const $elem = $('.retail-page section[role="acquire"] .acquire-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .removeClass(
      'facebook-button-click consent-loading consent consent-accepted website-loading website'
    )
    .fadeIn(300)
    .delay(1500)
    .toggleClass('facebook-button-click')
    .delay(500)
    .toggleClass('facebook-button-click consent-loading')
    .delay(500)
    .toggleClass('initial consent-loading consent')
    .delay(1500)
    .toggleClass('consent-accepted-button-click')
    .delay(500)
    .toggleClass('consent-accepted-button-click website-loading')
    .delay(800)
    .toggleClass('consent website-loading website');
}

function setupUnifyAnimation() {
  const $elem = $('.retail-page section[role="unify"] .unify-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .delay(200)
    .toggleClass('callout-1')
    .delay(200)
    .toggleClass('callout-2')
    .delay(200)
    .toggleClass('callout-3')
    .delay(200)
    .toggleClass('callout-4')
    .delay(200)
    .toggleClass('callout-5');
}

function setupPersonalizeAnimation() {
  const $elem = $('.retail-page section[role="personalize"] .personalize-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .delay(200)
    .toggleClass('callout-1')
    .delay(400)
    .toggleClass('callout-2')
    .delay(400)
    .toggleClass('callout-3');
}

function setupPartnerAnimation() {
  const $elem = $('.retail-page section[role="partner"] .partner-animation');
  const animation = new Animation($elem, { oneShot: true });

  return animation.addClass('arrows').delay(700).toggleClass('callouts');
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  next();
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}



// WEBPACK FOOTER //
// ./src/pages/retail/client.js